/**
 * 図書館画面の本から作った TODO (source='library_book') に、本の表紙と外部リンクを出す。
 */

import { ExternalLink } from 'lucide-react'

import { BookCover } from '@/pages/library-search/components/BookCover'
import { buildAmazonUrl, toIsbn10 } from '@/pages/library-search/lib/amazon-url'

type Props = {
  isbn: string
}

const linkClass =
  'inline-flex items-center gap-1 rounded-full border border-border/60 px-2 py-0.5 text-[11px] text-muted-foreground transition-colors hover:bg-muted hover:text-foreground'

export const TodoBookLink = ({ isbn }: Props) => {
  const amazonUrl = buildAmazonUrl(isbn, null)
  const isbn10 = toIsbn10(isbn)
  const calilUrl = isbn10 ? `https://calil.jp/book/${isbn10}` : null

  return (
    <div className="flex items-center gap-3">
      <BookCover isbn={isbn} className="w-10" />
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-[11px] text-muted-foreground">本から作った TODO・ISBN {isbn}</span>
        <div className="flex flex-wrap gap-1.5">
          {amazonUrl && (
            <a href={amazonUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
              <ExternalLink className="size-3" />
              Amazon
            </a>
          )}
          {calilUrl && (
            <a href={calilUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
              <ExternalLink className="size-3" />
              カーリル
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
